import PropTypes from 'prop-types';
import { SelectSearch } from 'mol-ui';
import { config } from 'config';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
const { turnTypes } = config;

const TurnTypePicker = ({
    disabled,
    onChange,
    value,
    width
}) => {

    const { t } = useTranslation();

    useEffect(() => {
        if (!!onChange && !isEmpty(turnTypes)) {
            onChange(turnTypes[0]);
        }
    }, []);

    const options = [
        { hidden: !turnTypes.includes('online'), label: t('Online'), value: 'online' },
        { hidden: !turnTypes.includes('presential'), label: t('Presencial'), value: 'presential' }
    ];
    const filteredOptions = options.filter(({ hidden }) => !hidden);

    return (
        <SelectSearch
            disabled={ filteredOptions.length < 2 || disabled }
            fontSize="14px"
            height="40px"
            margin="0px"
            options={ filteredOptions }
            placeholder={ t('Seleccionar un tipo de turno') }
            value={ filteredOptions.length === 2 ? value : turnTypes[0] }
            width={ width }
            onChange={ onChange }
        />
    );
};

TurnTypePicker.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.string,
    width: PropTypes.string
};

export default TurnTypePicker;
